/**
 * ValueWarden Web 应用入口
 */

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import { useAuthStore } from './stores/auth';
import './assets/main.css';

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);

// 初始化认证状态
const authStore = useAuthStore();
authStore.init();

app.mount('#app');
